// each route update triggers a store update
// the different startegies are defined in this file
import dataHelper from './data-helper.js';
import store, { initialState } from '../store/index.js';

export const homeDataLogic = {
  init: () => {
    let payload = { ...initialState };
    delete payload.bicsSelected;
    delete payload.bicsSelectedObj;
    store.dispatch('changeMode', payload);
    store.dispatch('getIndustries', {});
  }
};

export const searchDataLogic = {
  init: (route) => {
    const term = route.query.searchTerm;
    if (term) {
      store.dispatch('updateTerm', { term });
    }
    else {
      let payload = { ...initialState, mode: 'search' };
      delete payload.bicsSelected;
      delete payload.bicsSelectedObj;
      store.dispatch('changeMode', payload);
    }
  }
};

export const browsingDataLogic = {
  init: (route) => {
    const category = route.params.category;
    if (category) {
      store.dispatch('browseBics', { category });
    } 
    else { 
      let payload = { ...initialState, mode: 'browse' };
      delete payload.bicsSelected;
      delete payload.bicsSelectedObj;
      store.dispatch('changeMode', payload);
      store.dispatch('getIndustries', {});
    }
  }
};

export const selectedDataLogic = {
  init: (route) => {
    // const term = route.query.searchTerm
    const codes = route.query.codes.split(',');
    if (dataHelper.isValidCodeArray(codes)) {
      store.dispatch('selectBics', { bicsSelected: codes });
    }
  }
};

export const industryDataLogic = {
  init: (route) => {
    const industry = route.params.industry;
    if (industry) {
      store.dispatch('getIndustry', { industry });
    }
  }
};

export const divisionDataLogic = {
  init: (route) => {
    const sector = route.params.division;
    if (sector) {
      store.dispatch('getSector', { sector });
    }
  }
};